// 自定义弹窗提示
import {message} from "../view/sysManagement/utils/sysManagementUtils";

/**
 * 校验用户名
 * @param account
 * @returns {boolean}
 */
export function accountValidate(account) {
    if(!account){
        message.error("账号不能为空");
        return false;
    }
    // 转化为字符串
    account = (account + "").trim();

    // 空校验
    if (!account) {
        message.error("账号不能为空");
        return false;
    }

    if (account.length > 50) {
        message.error("账号最多可输入50字符");
        return false;
    }

    // 特殊字符校验
    let accountRegex = /^[0-9a-zA-Z]{1,50}$/;
    if (!accountRegex.test(account)) {
        message.error("账号只能包含数字、字母");
        return false;
    }

    return true;
}